import { useIntl } from 'react-intl';

import { type LocationSuggestion, poiDisplayText } from './LocationSuggestion.ts';

const poiCategoryTranslationId = (category: string) =>
    `intl-msg:ordercom-cloud-frontend.orders.address-autocomplete.poi-category.${category.toLowerCase().replace(/_/g, '-')}`;

type LocationSuggestionItemProps = {
    suggestion: LocationSuggestion;
};

export const LocationSuggestionItem = ({ suggestion }: LocationSuggestionItemProps) => {
    const intl = useIntl();

    if (suggestion.type === 'poi') {
        return (
            <span className='display-flex align-items-start justify-content-between gap-10 width-100pct'>
                <span className='min-width-0'>{poiDisplayText(suggestion)}</span>
                {suggestion.category && (
                    <span className='tag tag-small white-space-nowrap flex-shrink-0'>
                        {intl.formatMessage({
                            id: poiCategoryTranslationId(suggestion.category),
                            defaultMessage: suggestion.category,
                        })}
                    </span>
                )}
            </span>
        );
    }
    return <span>{suggestion.addressPreview}</span>;
};
